import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-oro bg-noche text-white" data-id="element-91" data-mp="9lbg511q9bdl">
      <div className="mx-auto max-w-2xl px-3 pb-4 pt-3 text-center sm:px-5" data-id="element-92" data-mp="4mi319qcrmdy">
        <p className="inline-block rounded-md bg-oro px-2 py-0.5 font-sub text-xs font-extrabold uppercase leading-tight text-noche sm:text-sm" data-id="element-93" data-mp="1297cg4ndx19u">
          Método de aprendizaje paso a paso
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="mt-2 font-display text-[1.45rem] uppercase leading-[1.1] text-white sm:text-4xl" data-id="element-94" data-mp="sb1cvtp1w785">
          El sistema completo de{' '}
          <span className="text-oro" data-id="element-95" data-mp="381xmt2oj9aca">Lengua y Literatura</span> para enseñar,
          estudiar y preparar clases{' '}
          <span className="bg-oro px-1.5 text-noche" data-id="element-96" data-mp="3j9k9f79139e0">sin empezar de cero</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-white/85" data-id="element-97" data-mp="3o6kfvj9sie5n">
          Accedé a contenidos organizados, actividades prácticas, evaluaciones
          y recursos didácticos para trabajar Lengua y Literatura en
          secundaria,{' '}
          <strong className="font-bold text-oro" data-id="element-98" data-mp="35a2hij0frg0f">
            sin perder horas buscando información, preparando materiales o
            intentando organizar todo por tu cuenta.
          </strong>
        </motion.p>

        <p className="mt-2 inline-block rounded-lg border-2 border-ciencia bg-noche-light px-3 py-1.5 font-sub text-xs font-extrabold uppercase leading-tight text-white sm:text-sm" data-id="element-99" data-mp="2vglkz78wzmt2">
          {PRODUCT_NAME} · <span className="text-oro" data-id="element-100" data-mp="2lml8gkbazfab">6 Tomos + 5 Bonos</span>
        </p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} className="mt-2 block overflow-hidden rounded-2xl border-4 border-oro bg-white" data-id="element-101" data-mp="s3mf683jc910">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-102" data-mp="deyjm1tovzb2" />
        </motion.a>

        <p className="mt-1.5 font-sub text-xs font-bold leading-snug text-white/85 sm:text-sm" data-id="element-103" data-mp="162c8dcn8hok3">
          {PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos.
        </p>

        <div className="mt-2.5" data-id="element-104" data-mp="x02zssbj059c">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-105" data-mp="x0uxq9slif2s">
            🚀 Sí, quiero acceder ahora
          </CtaButton>
          <p className="mt-2.5 text-xs font-semibold text-white/80" data-id="element-106" data-mp="3lqm1dvdxqztc">
            Acceso Digital Inmediato • Garantía de 7 Días
          </p>
        </div>
      </div>
    </header>;
}